<template>
	<div class="divide-y divide-gray-200">
		<ui-alert-errors
			v-if="errorMessages.length > 0"
			:messages="errorMessages"
		/>

		<tradable-terms-summary
			:offer="form"
			:large-view="true"
			class="px-6 pt-4 pb-6"
			:commodityFuture="commodityFuture"
		/>

		<div
			v-if="
				form.trade == 'BUY' &&
				form.location.mode == 'DAP' &&
				form.location.optional_transport &&
				user.acl.price_indication_edit
			"
			class="px-6 py-4 flex space-x-4 justify-end"
		>
			<label>
				{{ __("publish_only_in_price_ticker") }}
			</label>
			<ui-toggle v-model="form.only_visible_in_price_ticker" />
		</div>
		<div
			v-else-if="form.trade == 'BUY' && user.acl.price_indication_edit"
			class="px-6 py-4"
		>
			<p class="text-red-500">
				{{ __("priceticker_not_available_for_offer") }}
			</p>
		</div>

		<div
			v-if="form.trade !== 'BUY'"
			class="px-6 py-4 flex space-x-4 justify-end"
		>
			<label>
				{{ __("Make offer visible to potential clients") }}
			</label>

			<ui-toggle v-model="form.visible" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
	},
	computed: {
		errorMessages() {
			return Object.values(this.form.errors);
		},
		commodityFuture() {
			if (this.form.price.commodity_future_id) {
				let commodityFutureId = this.form.price.commodity_future_id;
				return this.activeFutures.filter((f) => f.id == commodityFutureId)[0];
			} else {
				return null;
			}
		},
	},
};
</script>
